import { useLocation } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'

import { TopBarDesktop } from '~/portal/components/ConsumerTopBar/desktop'
import { TopBarMobile } from '~/portal/components/ConsumerTopBar/mobile'
import appDefaults from '~/portal/portal.defaults.json'
import { LandingProduct } from '~/portal/types/product'
import { UserInfo } from '~/shared/types/user.ts'

export interface TopBarProps {
  accentColor?: string,
  logo?: string,
  logoHeight?: number,
  name?: string,
  user?: UserInfo,
  baseUrl?: string,
  fontFamily?: string,
  currentProduct?: LandingProduct,
  products?: Array<LandingProduct>,
  disabled?: boolean,
  hideStripes?: boolean,
  toggleSideNavWithTransition?: (value: boolean) => void,
  platformAdmin?: boolean,
  showNavToggle?: boolean,
}

export const TopBar = ({
  logo,
  logoHeight,
  accentColor,
  fontFamily,
  user,
  name,
  currentProduct,
  disabled,
  hideStripes,
  toggleSideNavWithTransition,
  products,
  platformAdmin,
  baseUrl,
  showNavToggle,
}: TopBarProps) => {

  const isMobile = useMediaQuery(appDefaults.media.mobile, { initializeWithValue: false })
  const { pathname } = useLocation()

  const isLandingPage = pathname === '/'

  return (
    <>
      {isMobile ? (
        <TopBarMobile
          logo={logo}
          logoHeight={logoHeight}
          accentColor={accentColor}
          fontFamily={fontFamily}
          user={user}
          accentDivider={isLandingPage}
          name={name}
          currentProduct={currentProduct}
          disabled={disabled}
          hideStripes={hideStripes}
          toggleSideNavWithTransition={toggleSideNavWithTransition}
          products={products}
          baseUrl={baseUrl}
          showNavToggle={showNavToggle}
        />
      ) : (
        <TopBarDesktop
          logo={logo}
          accentColor={accentColor}
          user={user}
          fontFamily={fontFamily}
          accentDivider={isLandingPage}
          name={name}
          currentProduct={currentProduct}
          products={products}
          disabled={disabled}
          hideStripes={hideStripes}
          platformAdmin={platformAdmin}
          baseUrl={baseUrl}
        />
      )}
    </>
  )
}